import axiosClient from '../axiosClient';
import { ENTITY_ROLE_API_URL } from '../constants';

const RoleEntity = {
  createRole: async (body: any) => {
    try {
      const response = await axiosClient.post(`${ENTITY_ROLE_API_URL}`, { ...body });
      return response.data;
    } catch (err: any) {
      return err.response.data;
    }
  },

  createRoleWithUpload: async (body: any) => {
    try {
      //Add formData
      const response = await axiosClient.post(`${ENTITY_ROLE_API_URL}/upload`, { ...body });
      return response.data;
    } catch (err: any) {
      return err.response.data;
    }
  },

  fetchRoles: async (params: any) => {
    try {
      const response = await axiosClient.get(ENTITY_ROLE_API_URL, { params });
      return response.data;
    } catch (err: any) {
      return err.response.data;
    }
  },

  uploadRoles: async (body: FormData) => {
    try {
      const response = await axiosClient.post(`${ENTITY_ROLE_API_URL}/upload`, body, {
        headers: {
          'Content-Type': 'multipart/form-data',
        },
      });
      return response.data;
    } catch (error: any) {
      return error?.response?.data;
    }
  },

  deleteRole: async (params: any) => {
    try {
      const response = await axiosClient.delete(ENTITY_ROLE_API_URL, { params });
      return response.data;
    } catch (error: any) {
      return error?.response?.data;
    }
  },
  updateRoleDetails: async (body: any) => {
    try {
      const response = await axiosClient.put(`${ENTITY_ROLE_API_URL}`, body);
      return response.data;
    } catch (error: any) {
      return error?.response?.data;
    }
  },
};

export default RoleEntity;